<template>
  <el-dialog :title="title"
             :visible.sync="modelValue"
             :close-on-click-modal="false"
             top="100px"
             @open="handleOpen"
             append-to-body
             destroy-on-close
             width="40%"
             :before-close="handleClose"
             custom-class="custom-dialog-class">
    <template #default >
      <div class="reference-picture-container" >
        <div class="form-container">
          <el-form
              :rules="rules"
              ref="formRef"
              label-width="100px"
              :model="form">
            <el-form-item label="菜肴名称：" prop="dishName">
              <span>{{ dishName }}</span>
            </el-form-item>
            <el-form-item label="参考图：" prop="imageCategoryId">
              <el-select v-model="form.imageCategoryId"
                         @change="handleChange"
                         clearable
                         placeholder="请选择">
                <el-option v-for="item in imageCategoryList"
                           :key="item.id"
                           :label="item.typeName"
                           :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="图片：" prop="">
              <template v-if="url" >
                <el-image class="imageClassName" :src="url" fit="fill" />
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer-container">
          <el-button type="primary" @click="confirmHandler" >确 认</el-button>
          <el-button @click="handleClose(closeHandler)">取 消</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "ReferencePicture",
  components: {

  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: () => ""
    },
    imageId: {
      type: String,
      default: () => ""
    },
    dishName: {
      type: String,
      default: () => ""
    },
  },
  data() {
    return {
      form: {
        imageCategoryId: "",
      },
      rules: {
        imageCategoryId: [
          { required: true, message: '请选择参考图', trigger: 'change' },
        ]
      },
      imageCategoryList: [],
      url: "",
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    title() {
      return "参考图";
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleChange(e) {
      console.log(`handleChange`, e);
      let obj = (this.imageCategoryList || []).find(item => item.id === e);
      if (obj) {
        this.url = obj.imageUrl;
      }
    },
    handleOpen() {
      this.getImageCategoryList();
    },
    async getImageCategoryList() {
      try {
        const res = await this.$get("imageCategory/list");
        if (!res) return false;
        const { data } = res;
        this.imageCategoryList = data;
        if (this.imageId) {
          this.form.imageCategoryId = this.imageId;
          this.handleChange(this.imageId);
        }
      }catch (e) {
        console.error(`获取通用类型列表失败: ${e}`);
      }
    },
    async confirmApi() {
      try {
        const res = await this.$post("imageCategory/bind", {
          dishId: this.id,
          ...this.form
        })
        if (!res) return false;
        this.$emit("updateList");
        this.handleClose(this.closeHandler);
      }catch (e) {
        console.error(`确菜肴和图片绑定认失败: ${e}`);
      }
    },
    confirmHandler() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          await this.confirmApi();
        }
      });
    },
    closeHandler() {
      this.modelValue = false;
    },
    handleClose(done) {
      this.url = "";
      this.imageCategoryList = [];
      this.$refs.formRef.resetFields();
      done();
    },
  },
}
</script>


<style scoped lang="scss">
.reference-picture-container{

}
.form-container{
  height: 380px;
  .el-input,.el-select{
    width: 260px;
  }
}
.footer-container{
  padding-top: 28px;
  border-top: 1px solid #EBECF0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button{
    width: 120px;
  }
  .el-button + .el-button{
    margin-left: 50px;
  }
}
.imageClassName{
  width: 320px;
  height: 190px;
  border-radius: 5px;
}
</style>
